import { render, staticRenderFns } from "./IbanList.vue?vue&type=template&id=2aebf8d8&"
import script from "./IbanList.vue?vue&type=script&lang=js&"
export * from "./IbanList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports